import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Allows additions of new phrases to improve speech recognition.
 *
 * Phrases added to the recognizer are effective at the start of the next recognition, or the next time the SpeechSDK must reconnect
 * to the speech service.
 */
export var PhraseListGrammar = /*#__PURE__*/function () {
  function PhraseListGrammar(recogBase) {
    _classCallCheck(this, PhraseListGrammar);

    this.privGrammerBuilder = recogBase.dynamicGrammar;
  }
  /**
   * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
   * @param recognizer The recognizer to add phrase lists to.
   */


  _createClass(PhraseListGrammar, [{
    key: "addPhrase",

    /**
     * Adds a single phrase to the current recognizer.
     * @param phrase Phrase to add.
     */
    value: function addPhrase(phrase) {
      this.privGrammerBuilder.addPhrase(phrase);
    }
    /**
     * Adds multiple phrases to the current recognizer.
     * @param phrases Array of phrases to add.
     */

  }, {
    key: "addPhrases",
    value: function addPhrases(phrases) {
      this.privGrammerBuilder.addPhrase(phrases);
    }
    /**
     * Clears all phrases added to the current recognizer.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.privGrammerBuilder.clearPhrases();
    }
  }], [{
    key: "fromRecognizer",
    value: function fromRecognizer(recognizer) {
      var recoBase = recognizer.internalData;
      return new PhraseListGrammar(recoBase);
    }
  }]);

  return PhraseListGrammar;
}();